<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="650"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <div style="margin-bottom: 10px; color: #fa9600">
        *可根据系统提供的模版进行填写后在上传，也可直接进行第二步
      </div>
      <div class="flex-align-center" style="margin-bottom: 10px">
        <span class="title-1">第一步：下载模版</span>
        <a style="margin-left: 10px" :href="templateUrl" @click="isDownload = true">
          下载心理评估访谈提纲记录表
        </a>
      </div>
      <a-upload-dragger
        :disabled="false"
        accept=".doc,.docx"
        name="file"
        :file-list="fileList"
        :multiple="true"
        :action="uploadAction"
        :headers="tokenHeader"
        @change="handleChange"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">添加文件</p>
        <p class="ant-upload-hint">(仅支持.doc或.docx格式的文件)</p>
      </a-upload-dragger>
      <div class="title-1" style="margin: 10px 0">第二步：评估</div>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 21 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="问题原因">
          <j-dict-select-tag
            v-model="form.tagId"
            placeholder="请选择问题原因"
            dictCode="emotional_type"
          />
        </a-form-model-item>
        <a-form-model-item label="关爱等级">
          <j-dict-select-tag
            v-model="form.careList"
            placeholder="请选择关爱等级"
            dictCode="care_list"
          />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea
            v-model="form.comment"
            :auto-size="{ minRows: 5, maxRows: 8 }"
            placeholder="请输入辅导内容"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction } from '@/api/manage'
import { getStoreFileUrl } from '@/utils/util'

export default {
  name: 'AssessModal',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '学生评估',
    },
  },
  data() {
    return {
      visible: false,
      templateUrl: getStoreFileUrl('/schoolEvaluation/中小学心理评估访谈提纲记录表.docx'),
      form: {},
      rules: {
        // name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        // dateRang: [{ required: true, message: '请选择日期范围', trigger: 'blur' }],
        // radius: [{ required: true, message: '请选择测评范围', trigger: 'blur' }],
        // evalWay: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      currEvalInfo: {},
      // uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=studentTag',
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=emotionComments',
      fileList: [],
    }
  },
  methods: {
    showModal(data, index) {
      this.form = { oldName: data.name, name: data.name }
      this.currEvalInfo = data
      console.log('数据：', data)
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
    },
    async handleOk() {
      const params = { studentId: this.currEvalInfo.studentId, dataType: 4, ...this.form }
      if (this.fileList.length) {
        params.file = this.fileList[this.fileList.length - 1].url
      }
      const res = await postAction('/aigoes/schoolWarnRecord/add', params)
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('refresh')
      } else {
        this.$message.error(res?.message || '评估失败')
      }
      this.hideModal()
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
      console.log('文件信息:', this.fileList)
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-body {
    padding: 10px 24px;
  }
}
</style>
